const noop = () => {}

export default {
  functional: true,

  render(h, context) {
    const { guest, plain, closeButton, lastButton } = context.props
    const onClose = context.listeners['close'] || noop
    const onLast = context.listeners['last'] || noop
    const isGuest = typeof guest !== 'undefined' && guest !== false

    const attr = {
      class: {
        "page-title": true,
        "is-guest": isGuest,
        "is-plain": plain
      }
    }

    const child = isGuest ? context.children : h('h1', context.children)
    const children = [child]

    if (closeButton) {
      const icon = h('i', {
        class: ['fas', 'fa-times', 'page-title-close'],
        on: { click: onClose }
      })
      children.push(icon)
    }

    if (lastButton) {
      const icon = h('i', {
        class: ['fas', 'fa-paper-plane', 'page-title-last'],
        on: { click: onLast }
      })
      children.push(icon)
    }

    const container = h('div', {
      class: ['page-title-content', 'container']
    }, children)

    return h('div', attr, [container])
  }
}
